import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

const messages = {
    tr: {
        message: {
            welcomeGreeting: "Merhaba! Hoş geldin 👋",
            welcomeStarting: "Sohbet başlatılıyor…",
            searchCountry: "Ara…",
            noResultFound: "Sonuç bulunamadı",
            welcomeCTA1: "Ürün hakkında bilgi almak istiyorum.",
            welcomeCTA2: "Teknik bir sorum var.",
            welcomeCTA3: "Fiyat teklifi istiyorum.",
            welcomeCardTitle: "Sizi daha yakından tanıyabilir miyiz?",
            welcomeCardSubmit: "Gönder",
            welcomeCardThanks: "Teşekkürler! 🎉",
            welcomeFieldFullname: "Ad Soyad",
            welcomeFieldEmail: "E-posta adresiniz",
            welcomeFieldPhone: "Telefon numaranız",
            welcomeErrorPhone: "Telefon numarası geçerli görünmüyor",
            welcomePrecallHint: "Mesajınızı yazın…",
            welcomeComposerLocked: "Önce yukarıdaki formu doldurun",
            welcomeHintName: "Adınızı yazın…",
            welcomeHintEmail: "E-postanızı yazın…",
            welcomeHintDefault: "Cevabınızı yazın…",
            welcomeAskName: "Öncelikle adınızı öğrenebilir miyim?",
            welcomeAskEmail: "Teşekkürler! E-posta adresinizi de alabilir miyim?",
            welcomeAskSubject: "Hangi konuda yardımcı olabilirim?",
            welcomeErrorRequired: "Bu alanı boş bırakamayız, tekrar dener misiniz?",
            welcomeErrorEmail: "Bu e-posta geçerli görünmüyor, tekrar dener misiniz?",
            welcomeErrorNumeric: "Buraya yalnızca sayı yazabilirsiniz, tekrar dener misiniz?",
            welcomeChooseAbove: "Yukarıdan seçim yapın",
            welcomeSkip: "Atla",
            welcomeSkipped: "Şimdilik geçiyorum",
            welcomeConsentAccept: "Onaylıyorum",
            welcomeConsentAccepted: "Onaylıyorum",
            welcomeStepContinue: "Devam",
            back: "Geri",
            welcomeContinue: "Devam",
            welcomeStart: "Sohbeti başlat",
            closeChat: "Sohbeti Kapat",
            speechTermination: "Konuşmayı Sonlandır",
            You: "Siz",
            locationPermsNeeded: "Bu özelliği kullanabilmeniz için konum izinleri gerekli",
            useMyLocation: "Konumumu kullan",
            selectChatLang: "Konuşma Dili Seçin",
            feedbackUs: "Üzgünüm, sizi anlayamadım.",
            typeInAgain: "Tekrar yazmayı deneyiniz.",
            volumeUp: "Sesi Aç",
            minimize: "Küçült",
            maximize: "Büyüt",
            autoTranslate: "Otomatik Tercüme",
            on: "Açık",
            off: "Kapalı",
            currentLang: "Konuşma Dilini Değiştir: {lang}",
            languageSelection: "Dil Seçimi",
            translatedTextDescription: "Amazon  bu mesajın {from} -> {to} çevirisini yapmıştır.",
            translatedInfoTextDescription: "SUPSİS bu mesajın {from} -> {to} çevirisini yapmıştır.",
            save: "Kaydet",
            loadMore: "Daha Fazla Yükle",
            loading: "Yükleniyor...",
            chatDate: "Konuşma Tarihi: ",
            chatHistory: "Konuşma Geçmişi",
            supportTeam: "Destek Ekibi",
            searchChat: "Konuşmalarda ara",
            noChatHistory: "Henüz bir konuşma yok",
            goback: "Geri Dön",
            noHistory: "Konuşma Geçmişi Bulunamadı...",
            close: "Kapat",
            createTicket: "Mesajınızı Bırakın",
            creatingTicketMsg: "Ticket Oluşturuluyor ...",
            createdTicketMsg: "Ticket Başarıyla Oluşturuldu!",
            deletingPersonalDataMsg: "Tüm Kişisel Veriler Siliniyor ...",
            deletedPersonalDataMsg: "Tüm Kişisel Veriler Başarıyla Silindi!",
            deleteKVVK: "Tüm Bilgilerimi Sil",
            ticketMode: "Ticket mesajı gönder",
            nextStep: "Sıradaki adımınız ne olsun?",
            viewConversation: "Konuşmayı Görüntüle",
            openRatingAgain: "Puanlamayı Aç  ",
            terrible: "Berbat",
            bad: "Kötü",
            normal: "Normal",
            good: "İyi",
            wonderful: "Muhteşem",
            feedbackImportant: "Geri bildiriminiz bizim için önemli.",
            feedbackThanksMessage: "Geri bildiriminiz için teşekkür ederiz.",
            withVideo: "Görüntülü",
            withSound: "Sesli",
            download: "Dosya'yı İndir",
            representative: "Temsilci",
            vcCallingForScreen: "{userAgent}, Sizin ekranınızı görmek istiyor...",
            vcCalling: "{userAgent}, Sizinle {medium} konuşma talep ediyor...",
            no: "Hayır",
            didHelpful: "İçerik yardımcı oldu mu?",
            howCanHelp: "Size nasıl yardımcı olabiliriz?",
            offline: "Çevrimdışı",
            city: "Şehir",
            district: "İlçe",
            messageSent: "Mesajınız gönderildi.Size en kısa zamanda mail yoluyla dönüş yapacağız.",
            sendMessage: "Mesaj gönder",
            noRepresentative:
                "Hiç bir temsilcimiz şuanda aktif değil. Mesajınızı ileterek size mail yoluyla ulaşmamızı ister misiniz? ",
            and: "ve",
            queueNumberDesc: `Sıranız # {number}`,
            logWithSaved: "Daha önce bağlandığınız bilgilerle bağlanabilirsiniz.",
            differentUser: "Farklı hesap",
            waitRepresentative: "Temsilci bekleniyor",
            isHelp: "{userAgent} size yardımcı oldu mu?",
            writePlaceHolder: "Mesajınızı yazın…",
            messageTextPlaceHolder: "Mesaj",
            transcriptSending: "Gönderiliyor",
            transcriptSent: "Kopya gönderildi",
            sendTranscript: "Konuşmayı Epostama gönder",
            sendAgainTranscript: "Konuşmayı Epostama tekrar gönder",
            startChatAgain: "Tekrar bağlan",
            lostConnection: "Bağlantınız koptu. Lütfen internet bağlantınızın olduğundan emin olunuz.",
            helpDesk: "Canlı destek uygulaması",
            others: "Diğerleri",
            you: "Sen",
            sureCloseChat: "Sohbeti kapatmak istediğinize emin misiniz?",
            connectToLiveSupport: "Canlı Desteğe Bağlan",
            chatWithUs: "Bizimle sohbet edin",
            error: "Hata",
            endChat: "Sohbeti Sonlandır",
            liveSup: "Canlı Destek",
            connLost: "Bağlantınız koptu. Lütfen internet bağlantınızın olduğundan emin olunuz.",
            reConnect: "Yeniden Bağlan",
            evaluate: "Değerlendir",
            cancel: "Vazgeç",
            welcomeLiveSup: "Canlı yardım servisine hoşgeldiniz. Size nasıl yardımcı olabiliriz?",
            yes: "Evet",
            yourName: "Ad Soyad",
            yourEmail: "E-posta Adresi",
            phone: "Telefon",
            phonePlaceholder: "Lütfen telefon numarasını giriniz",
            yourUsername: "Kullanıcı Adı",
            selectTopic: "Konu Seçiniz",
            connect: "BAĞLAN",
            topic: "Konu:",
            feedback: "Size daha iyi yardımcı olabişmek için lütfen görüşlerinizi belirtiniz...",
            rateConvo: "Görüşmeyi Değerlendir",
            reviewThank: "Değerlendirmeniz için teşekkür ederiz!",
            seeYou: "Görüşleriniz bizim için değerlidir. Tekrar görüşmek üzere!",
            name: "Ad",
            email: "E-posta adresi",
            username: "Kullanıcı Adı",
            subject: "Konu",
            pleaseWaitConnectUser: "Lütfen bekleyin, temsilcilerimizden biri müsait olduğunda bağlanacaktır",
            reconnecting: "Sunucu ile bağlantınız koptu, yeniden bağlanılıyor lütfen bekleyiniz ...",
            connecting: "Sunucu ile bağlantınız kuruluyor, lütfen bekleyiniz...",
            send: "Gönder",
            descriptionPlaceHolder: "Öneri ve görüşlerinizi belirterek bize geri bildirimde bulunabilirsiniz.",
            messagePhone: "Lütfen telefon numaranızı uygun formatta giriniz.",
            visitorEmailIsNotValid: "Girdiniz eposta adresi doğru değil",
            "preferredResponseMethod": "Tercih Ettiğiniz Yanıt Yöntemi",
            "responseViaEmail": "E-posta ile yanıt",
            "responseViaWhatsapp": "WhatsApp ile yanıt"

        },
        chatbot: {
            preMenu: "Bir önceki menü",
            transferPreMenu: "Bir önceki menüye aktarıyorum",
            liveSup: "Canlı Destek",
            transferLiveSup: "Sizi canlı desteğe aktarıyorum",
        },
        catalog: {
            catalog: "Katalog",
            searchPH: "Cevap Ara",
            allCategory: "Tüm Kategoriler",
            lastUpdate: "Son Güncelleme",
            views: "Görüntülenme",
            reactionPrompt: "Bu makale yardımcı oldu mu?",
            thanks: "Teşekkürler",
            sendMessage: "Bize yazın",
        },
        shell: {
            searchResultCount: "{n} sonuç",
            messagesSearch: "Mesajlarda ara…",
            home: "Ana Sayfa", messages: "Mesajlar", help: "Yardım",
            askTitle: "Soru sor", askSubtitle: "Botumuz ve ekibimiz yardımcı olabilir", continueChat: "Son konuşmaya dön",
            searchArticles: "Yardım makalesi arayın", searchPlaceholder: "Makalelerde ara…", noArticles: "Henüz makale yok",
            greeting: "Merhaba! 👋", headline: "Nasıl yardımcı olabiliriz?",
            noConversations: "Henüz konuşma yok", startNew: "Yeni konuşma başlat", supportTeam: "Destek Ekibi",
            loadFailed: "Mesajlar yüklenemedi",
            helpSearch: "Yardımda ara…", articleCount: "{n} makale", helpEmpty: "Sonuç bulunamadı", startChat: "Sohbet başlat", collections: "Koleksiyonlar", articles: "Makaleler", helpLoadFailed: "İçerik yüklenemedi",
        },
        akinon: {
            chooseAddress: "Adres Seç",
            useMap: "Haritayı Kullan",
            selectCountry: "Ülke Seç",
            country: "Ülke",
            send: "Gönder",
            selectCity: "İlçe Seçin",
            city: "İlçe",
            selectState: "İlinizi Seçin",
            state: "İl",
        },
        visitorLanguage: {
            rateTheMeting: "ile görüşmeni oyla",
            rateTheEmptyMeting: "Görüşmeyi Değerlendir.",
            confirmExperience: "Supsis Deneyimini Oyla",
            addFile: "Dosya Ekle",
            submitLocation: "Konum Gönder",
            customerRepresentative: "Müşteri Temsilcisi",
            emailAdress: "E-posta Adresi",
            send: "Gönder",
            evaluation: "Değerlendirme için",
            thankYouEvaluation: "teşekkür ederiz!",
            hasEmailError: "E-posta Hatalı",
            reconnect: "Tekrar Bağlan",
            sendTheConversationToEmail: "Konuşmayı e-postama gönder",
            youDidNotAllowLocationAccess: "Konum erişimine izin vermediniz!",
            allowLocationAccess: "Konum erişimi için izin vermek istiyor musunuz?",
            locationNotSupported: "Bu tarayıcıda konum hizmeti desteklenmiyor.",
            deleteConversation: "Tüm bilgilerinizi silmek İstediğinize emin misiniz?",
            endTheConversation: "Görüşmeyi sonlandırmak istediğinizden emin misiniz?",
            suggestionAndOpinion: "Öneri ve Görüşlerinizi Belirtin",
            suggestion: "Öneri ve görüşlerinizi almak isteriz.",
            skip: "Atla",
        },
    },
    en: {
        message: {
            welcomeGreeting: "Hi there! Welcome 👋",
            welcomeStarting: "Starting the chat…",
            searchCountry: "Search…",
            noResultFound: "No results found",
            welcomeCTA1: "I'd like information about the product.",
            welcomeCTA2: "I have a technical question.",
            welcomeCTA3: "I'd like a price quote.",
            welcomeCardTitle: "May we get to know you better?",
            welcomeCardSubmit: "Send",
            welcomeCardThanks: "Thank you! 🎉",
            welcomeFieldFullname: "Full name",
            welcomeFieldEmail: "Your email address",
            welcomeFieldPhone: "Your phone number",
            welcomeErrorPhone: "That phone number does not look valid",
            welcomePrecallHint: "Type your message…",
            welcomeComposerLocked: "Fill in the form above first",
            welcomeHintName: "Type your name…",
            welcomeHintEmail: "Type your email…",
            welcomeHintDefault: "Type your answer…",
            welcomeAskName: "First, may I have your name?",
            welcomeAskEmail: "Thanks! What is your email address?",
            welcomeAskSubject: "What can I help you with?",
            welcomeErrorRequired: "We cannot leave this blank, could you try again?",
            welcomeErrorEmail: "That email does not look valid, could you try again?",
            welcomeErrorNumeric: "Only numbers here, could you try again?",
            welcomeChooseAbove: "Pick an option above",
            welcomeSkip: "Skip",
            welcomeSkipped: "I will skip this for now",
            welcomeConsentAccept: "I agree",
            welcomeConsentAccepted: "I agree",
            welcomeStepContinue: "Continue",
            back: "Back",
            welcomeContinue: "Continue",
            welcomeStart: "Start chat",
            closeChat: "Close Chat",
            speechTermination: "End Conversation",
            You: "You",
            locationPermsNeeded: "Location permissions are needed to use this feature",
            useMyLocation: "Use my location",
            selectChatLang: "Select Spoken Language",
            feedbackUs: "I'm sorry, I didn't understand you.",
            typeInAgain: "Try typing again.",
            volumeUp: "Volume Up",
            minimize: "Minimize",
            maximize: "Maximize",
            autoTranslate: "Auto Translate",
            on: "on",
            off: "off",
            currentLang: "Change Language: {lang}",
            languageSelection: "Language Selection",
            translatedTextDescription: "Amazon translated this message {from} -> {to}.",
            save: "Save",
            createTicket: "Leave Your Message",
            creatingTicketMsg: "Ticket is Creating ...",
            createdTicketMsg: "Ticket Created Successfully!",
            deletingPersonalDataMsg: "All Personal Data is deleting ...",
            deletedPersonalDataMsg: "All Personal Data Deleted Successfully!",
            visitorEmailIsNotValid: "Visitor email is not valid",
            loadMore: "Load More",
            loading: "Loading ...",
            chatDate: "Chat Date: ",
            chatHistory: "Chat History",
            supportTeam: "Support Team",
            searchChat: "Search conversations",
            noChatHistory: "No conversations yet",
            goback: "Go Back",
            noHistory: "There is no chat archived",
            close: "Close",
            deleteKVVK: "Delete Personal Data",
            ticketMode: "Send Ticket Message",
            nextStep: "What is next?",
            viewConversation: "View Conversation",
            openRatingAgain: "Open Rating  ",
            terrible: "Terrible",
            bad: "Bad",
            normal: "Normal",
            good: "Good",
            wonderful: "Wonderful",
            feedbackThanksMessage: "Thank you for your feedback.",
            feedbackImportant: "Feedback is very important for us.",
            withVideo: "video",
            withSound: "voice",
            download: "Download File",
            representative: "Representative",
            vcCallingForScreen: "{userAgent}, is asking for share your screen...",
            vcCalling: "{userAgent}, would like to {medium} call with you...",
            no: "No",
            didHelpful: "Was it helpful?",
            howCanHelp: "How can we help you?",
            offline: "Offline",
            city: "City",
            district: "District",
            messageSent: "Your message has been sent. We will return to you via e-mail as soon as possible.",
            sendMessage: "Send message",
            noRepresentative:
                "There is no active representative right now. We can reach you with email if you send a message.  ",
            descriptionPlaceHolder: "You can give us feedback by stating your suggestions and opinions.",
            and: "and",
            queueNumberDesc: `Queue # {number}`,
            logWithSaved: "Login with saved history",
            differentUser: "Different User",
            send: "Send",
            waitRepresentative: "Waiting an agent..",
            isHelp: "Did {userAgent} help you?",
            writePlaceHolder: "Write a message…",
            messageTextPlaceHolder: "Message",
            transcriptSending: "Sending",
            transcriptSent: "Transcript was sent",
            sendTranscript: "Send Transcript",
            sendAgainTranscript: "Send Again Transcript",
            startChatAgain: "Start chat again",
            lostConnection: "Your internet connection lost. Please check your internet connection.",
            helpDesk: "Help desk software by",
            others: "Others",
            you: "You",
            sureCloseChat: "Are you sure close the chat?",
            connectToLiveSupport: "Connect to Live Support",
            chatWithUs: "Chat with us",
            error: "Error",
            endChat: "End Chat",
            liveSup: "Live Support",
            connLost: "You're disconnected. Please make sure your internet connection.",
            reConnect: "Reconnect",
            evaluate: "Evaluate",
            cancel: "Cancel",
            welcomeLiveSup: "Welcome to the live support service. How can we help you?",
            yes: "Yes",
            yourName: "Full Name",
            yourEmail: "Email",
            phone: "Telephone",
            phonePlaceholder: "Enter a phone number",
            yourUsername: "Username",
            selectTopic: "Select Topic",
            connect: "CONNECT",
            topic: "Topic:",
            feedback: "Please provide your feedback to help you better...",
            rateConvo: "Rate Conversation",
            reviewThank: "Thank you for your review!",
            seeYou: "Your feedback is valuable to us. See you again!",
            name: "Name",
            email: "Email address",
            username: "Username",
            subject: "Subject",
            pleaseWaitConnectUser: "Please wait one of our representatives will be connected when available",
            reconnecting: "Your connection with the server has been lost, reconnecting please wait ...",
            connecting: "Connecting to server ,please wait...",
            messagePhone: "Please enter your phone number in the appropriate format.",
            preferredResponseMethod: "Preferred Response Method",
            responseViaEmail: "Response via Email",
            responseViaWhatsapp: "Response via WhatsApp"
        },
        chatbot: {
            preMenu: "Previous menu",
            transferPreMenu: "Transfer to previous menu",
            liveSup: "Live Support",
            transferLiveSup: "Connecting to  live support",
        },
        catalog: {
            catalog: "Catalog",
            searchPH: "Search for answer",
            allCategory: "All Categories",
            lastUpdate: "Last Update",
            views: "Views",
            reactionPrompt: "Did this article help?",
            thanks: "Thanks",
            sendMessage: "Send us a message",
        },
        shell: {
            searchResultCount: "{n} results",
            messagesSearch: "Search messages…",
            home: "Home", messages: "Messages", help: "Help",
            askTitle: "Ask a question", askSubtitle: "Our bot and team can help", continueChat: "Back to last conversation",
            searchArticles: "Search help articles", searchPlaceholder: "Search articles…", noArticles: "No articles yet",
            greeting: "Hi there! 👋", headline: "How can we help?",
            noConversations: "No conversations yet", startNew: "Start a new conversation", supportTeam: "Support Team",
            loadFailed: "Messages could not be loaded",
            helpSearch: "Search help…", articleCount: "{n} articles", helpEmpty: "No results found", startChat: "Start a chat", collections: "Collections", articles: "Articles", helpLoadFailed: "Content could not be loaded",
        },
        akinon: {
            chooseAddress: "Choose Address",
            useMap: "Use Map",
            selectCountry: "Select Country",
            country: "Country",
            send: "Send",
            selectCity: "Select City",
            city: "City",
            selectState: "Select State",
            state: "State",
        },
        visitorLanguage: {
            rateTheMeting: "rate your meeting with",
            rateTheEmptyMeting: "Would you like to rate the conversation?",
            confirmExperience: "Rate Supsis Experience",
            addFile: "Add file",
            submitLocation: "Send location",
            customerRepresentative: "Customer Representative",
            emailAdress: "E-mail address",
            send: "Send",
            evaluation: "For evaluation",
            thankYouEvaluation: "we thank you!",
            hasEmailError: "Email Incorrect",
            reconnect: "Reconnect",
            sendTheConversationToEmail: "Send the conversation to my email",
            youDidNotAllowLocationAccess: "You did not allow location access!",
            allowLocationAccess: "Do you want to allow for location access?",
            locationNotSupported: "Location service is not supported in this browser.",
            deleteConversation: "Are you sure you want to delete all your information?",
            endTheConversation: "Are you sure you want to end the call?",
            suggestionAndOpinion: "Give Your Suggestions and Opinions",
            suggestion: "We would like to receive your suggestions and opinions.",
            skip: "Skip",
        },
    },
    ru: {
        message: {
            welcomeGreeting: "Здравствуйте! Добро пожаловать 👋",
            welcomeStarting: "Чат запускается…",
            searchCountry: "Поиск…",
            noResultFound: "Ничего не найдено",
            welcomeCTA1: "Хочу узнать о продукте.",
            welcomeCTA2: "У меня технический вопрос.",
            welcomeCTA3: "Хочу получить коммерческое предложение.",
            welcomeCardTitle: "Можем узнать вас поближе?",
            welcomeCardSubmit: "Отправить",
            welcomeCardThanks: "Спасибо! 🎉",
            welcomeFieldFullname: "Имя и фамилия",
            welcomeFieldEmail: "Ваш адрес эл. почты",
            welcomeFieldPhone: "Ваш номер телефона",
            welcomeErrorPhone: "Номер телефона выглядит недействительным",
            welcomePrecallHint: "Введите сообщение…",
            welcomeComposerLocked: "Сначала заполните форму выше",
            welcomeHintName: "Введите имя…",
            welcomeHintEmail: "Введите e-mail…",
            welcomeHintDefault: "Введите ответ…",
            welcomeAskName: "Для начала, как вас зовут?",
            welcomeAskEmail: "Спасибо! Укажите, пожалуйста, вашу электронную почту.",
            welcomeAskSubject: "С каким вопросом помочь?",
            welcomeErrorRequired: "Это поле нельзя оставить пустым — попробуете ещё раз?",
            welcomeErrorEmail: "Этот адрес выглядит неверным — попробуете ещё раз?",
            welcomeErrorNumeric: "Здесь можно вводить только цифры — попробуете ещё раз?",
            welcomeChooseAbove: "Выберите вариант выше",
            welcomeSkip: "Пропустить",
            welcomeSkipped: "Пока пропущу",
            welcomeConsentAccept: "Согласен",
            welcomeConsentAccepted: "Согласен",
            welcomeStepContinue: "Продолжить",
            back: "Назад",
            welcomeContinue: "Продолжить",
            welcomeStart: "Начать чат",
            closeChat: "Закрыть чат",
            speechTermination: "закончить разговор",
            You: "Вы",
            locationPermsNeeded: "Необходимые разрешения на местоположение",
            useMyLocation: "Использовать мою локацию ",
            selectChatLang: "Выберите разговорный язык",
            feedbackUs: "Простите, я вас не понял.",
            typeInAgain: "Попробуйте ввести еще раз.",
            createTicket: "Оставьте свое сообщение",
            creatingTicketMsg: "Билет является определяющим ...",
            createdTicketMsg: "Билет успешно создан!",
            deletingPersonalDataMsg: "Все личные данные удалены ...",
            visitorEmailIsNotValid: "Электронная почта посетителя недействительна",
            deletedPersonalDataMsg: "Все личные данные успешно удалены!",
            loadMore: "Загрузи больше",
            loading: "Загрузка ...",
            chatDate: "Дата чата: ",
            chatHistory: "История чата",
            supportTeam: "Служба поддержки",
            searchChat: "Поиск по чатам",
            noChatHistory: "Пока нет чатов",
            goback: "Вернитесь назад",
            noHistory: "Нет чата в архиве",
            close: "Закрывать",
            deleteKVVK: "Удалить личные данные",
            ticketMode: "Отправить сообщение о билете",
            nextStep: "Что следующее?",
            feedbackImportant: "Обратная связь очень важна для нас.",
            withVideo: "видео",
            withSound: "голос",
            volumeUp: "Нажмите",
            viewConversation: "Посмотреть беседу",
            feedbackThanksMessage: "Спасибо за ваш отзыв.",
            minimize: "Минимизировать",
            maximize: "Максимизировать",
            autoTranslate: "Автоматический перевод",
            on: "вкл",
            off: "выкл",
            currentLang: "Изменить язык: {lang}",
            languageSelection: "Выбор языка",
            translatedTextDescription: "Амазонка перевел это сообщение {from} -> {to}.",
            save: "Сохранять",
            download: "Скачать Файл",
            openRatingAgain: "Открытый рейтинг  ",
            terrible: "Ужасный",
            bad: "Плохой",
            normal: "Нормальный",
            good: "Хорошо",
            wonderful: "Чудесно",
            representative: "Представитель",
            vcCallingForScreen: "{userAgent}, просит показать ваш экран",
            vcCalling: "{userAgent}, хотел бы поговорить с вами по видеосвязи",
            no: "Нет",
            didHelpful: "Было ли это полезно",
            howCanHelp: "Как мы можем тебе помочь?",
            offline: "Не в сети",
            city: "Город",
            district: "Округ",
            messageSent: "Ваше сообщение отправлено. Мы свяжемся с вами по электронной почте как можно скорее.",
            sendMessage: "Отправить сообщение",
            noRepresentative:
                "Сейчас активного представителя нет. Мы свяжемся с вами по электронной почте, если вы отправите сообщение.",
            descriptionPlaceHolder: "Вы можете оставить нам отзыв, изложив свои предложения и мнения.",
            and: "и",
            queueNumberDesc: `Очередь # {number}`,
            logWithSaved: "Вход с сохраненной историей",
            differentUser: "Другой пользователь",
            send: "послать",
            waitRepresentative: "Жду представителя..",
            isHelp: "{userAgent} вам помог?",
            writePlaceHolder: "Напишите сообщение…",
            messageTextPlaceHolder: "Сообщение",
            transcriptSending: "Отправка",
            transcriptSent: "Стенограмма отправлена",
            sendTranscript: "Отправить стенограмму",
            sendAgainTranscript: "отправить еще раз расшифровку",
            startChatAgain: "Начать чат снова",
            lostConnection: "Ваше интернет-соединение потеряно. Пожалуйста, проверьте ваше интернет-соединение.",
            helpDesk: "Программное обеспечение службы поддержки от",
            others: "Другие",
            you: "Ты",
            sureCloseChat: "Вы уверены, что закрыли чат?",
            connectToLiveSupport: "Подключитесь к Live Support",
            chatWithUs: "Чат с нами",
            error: "Ошибка",
            endChat: "Конец чат",
            liveSup: "Живая поддержка",
            connLost: "Вы отключены. Убедитесь, что у вас есть подключение к Интернету.",
            reConnect: "Повторно подключиться",
            evaluate: "Оценивать",
            cancel: "Отмена",
            welcomeLiveSup: "Добро пожаловать в службу поддержки в реальном времени. Как мы можем тебе помочь?",
            yes: "да",
            yourName: "Полное имя",
            yourEmail: "Ваш адрес электронной почты",
            phone: "телефон",
            phonePlaceholder: "Введите номер телефона",
            yourUsername: "Имя пользователя",
            selectTopic: "Выберите тему",
            connect: "СОЕДИНЯТЬ",
            topic: "Тема:",
            feedback: "Пожалуйста, поделитесь своим мнением, чтобы помочь вам лучше...",
            rateConvo: "Оценить разговор",
            reviewThank: "Спасибо за отзыв!",
            seeYou: "Ваш отзыв очень важен для нас. Увидимся!",
            name: "Имя",
            email: "Эл. адрес",
            username: "Имя пользователя",
            subject: "Тема",
            pleaseWaitConnectUser:
                "Пожалуйста, подождите, один из наших представителей свяжется, когда будет доступен.",
            reconnecting: "Ваше соединение с сервером было потеряно, повторное подключение, пожалуйста, подождите...",
            connecting: "Подключение к серверу, подождите ...",
            messagePhone: "Пожалуйста, введите свой номер телефона в соответствующем формате.",
            preferredResponseMethod: "Предпочтительный метод ответа",
            responseViaEmail: "Ответ по электронной почте",
            responseViaWhatsapp: "Ответ по WhatsApp"
        },
        chatbot: {
            preMenu: "Предварительное меню",
            transferPreMenu: "Перевод в предварительное меню",
            liveSup: "Живая поддержка",
            transferLiveSup: "Перевод в живую поддержку",
        },
        catalog: {
            catalog: "Каталог",
            searchPH: "Поиск",
            allCategory: "Все категории",
            lastUpdate: "Последнее обновление",
            views: "Просмотры",
            reactionPrompt: "Эта статья помогла?",
            thanks: "Спасибо",
            sendMessage: "Напишите нам",
        },
        shell: {
            searchResultCount: "Результатов: {n}",
            messagesSearch: "Поиск по сообщениям…",
            home: "Главная", messages: "Сообщения", help: "Помощь",
            askTitle: "Задать вопрос", askSubtitle: "Наш бот и команда могут помочь", continueChat: "Вернуться к последнему разговору",
            searchArticles: "Поиск статей помощи", searchPlaceholder: "Поиск статей…", noArticles: "Пока нет статей",
            greeting: "Привет! 👋", headline: "Чем мы можем помочь?",
            noConversations: "Пока нет разговоров", startNew: "Начать новый разговор", supportTeam: "Служба поддержки",
            loadFailed: "Не удалось загрузить сообщения",
            helpSearch: "Поиск по справке…", articleCount: "{n} статей", helpEmpty: "Ничего не найдено", startChat: "Начать чат", collections: "Разделы", articles: "Статьи", helpLoadFailed: "Не удалось загрузить содержимое",
        },
        akinon: {
            chooseAddress: "Выберите адрес",
            useMap: "Использовать карту",
            selectCountry: "Выберите страну",
            country: "Страна",
            send: "Отправлять",
            selectCity: "Выберите город",
            city: "Город",
            selectState: "Выберите штат",
            state: "Состояние",
        },
        visitorLanguage: {
            rateTheMeting: "оцените встречу с",
            rateTheEmptyMeting: "Would you like to rate the conversation?",
            confirmExperience: "Оцените дополнительный опыт",
            addFile: "Добавить файл",
            submitLocation: "Отправить местоположение",
            customerRepresentative: "Представитель клиента",
            emailAdress: "Адрес электронной почты",
            send: "послать",
            evaluation: "Для оценки",
            thankYouEvaluation: "спасибо тебе!",
            hasEmailError: "Электронная почта неверна",
            reconnect: "Повторное подключение",
            sendTheConversationToEmail: "Отправить разговор на мою электронную почту",
            youDidNotAllowLocationAccess: "Вы не разрешили доступ к местоположению!",
            allowLocationAccess: "Разрешить доступ к местоположению?",
            locationNotSupported: "Служба определения местоположения не поддерживается в этом браузере.",
            deleteConversation: "Вы уверены, что хотите удалить всю свою информацию?",
            endTheConversation: "Вы уверены, что хотите завершить вызов?",
            suggestionAndOpinion: "Дайте свои предложения и мнения",
            suggestion: "Мы хотели бы получить ваши предложения и мнения.",
            skip: "Пропускать",
        },
    },
    de: {
        message: {
            welcomeGreeting: "Hallo! Willkommen 👋",
            welcomeStarting: "Chat wird gestartet…",
            searchCountry: "Suchen…",
            noResultFound: "Keine Ergebnisse gefunden",
            welcomeCTA1: "Ich möchte Informationen zum Produkt.",
            welcomeCTA2: "Ich habe eine technische Frage.",
            welcomeCTA3: "Ich hätte gern ein Angebot.",
            welcomeCardTitle: "Dürfen wir Sie näher kennenlernen?",
            welcomeCardSubmit: "Senden",
            welcomeCardThanks: "Danke! 🎉",
            welcomeFieldFullname: "Vor- und Nachname",
            welcomeFieldEmail: "Ihre E-Mail-Adresse",
            welcomeFieldPhone: "Ihre Telefonnummer",
            welcomeErrorPhone: "Diese Telefonnummer scheint ungültig zu sein",
            welcomePrecallHint: "Schreiben Sie Ihre Nachricht…",
            welcomeComposerLocked: "Bitte zuerst das Formular oben ausfüllen",
            welcomeHintName: "Namen eingeben…",
            welcomeHintEmail: "E-Mail eingeben…",
            welcomeHintDefault: "Antwort eingeben…",
            welcomeAskName: "Zuerst: Wie heißen Sie?",
            welcomeAskEmail: "Danke! Wie lautet Ihre E-Mail-Adresse?",
            welcomeAskSubject: "Wobei kann ich Ihnen helfen?",
            welcomeErrorRequired: "Dieses Feld darf nicht leer bleiben – versuchen Sie es bitte erneut.",
            welcomeErrorEmail: "Diese E-Mail sieht ungültig aus – versuchen Sie es bitte erneut.",
            welcomeErrorNumeric: "Hier sind nur Zahlen erlaubt – versuchen Sie es bitte erneut.",
            welcomeChooseAbove: "Wählen Sie oben eine Option",
            welcomeSkip: "Überspringen",
            welcomeSkipped: "Das überspringe ich fürs Erste",
            welcomeConsentAccept: "Ich stimme zu",
            welcomeConsentAccepted: "Ich stimme zu",
            welcomeStepContinue: "Weiter",
            back: "Zurück",
            welcomeContinue: "Weiter",
            welcomeStart: "Chat starten",
            closeChat: "Chat schließen",
            speechTermination: "Gespräch beenden",
            You: "Sie",
            locationPermsNeeded: "Standortberechtigungen erforderlich",
            useMyLocation: "Meinen Standort verwenden",
            selectChatLang: "Wählen Sie Ihre Sprache",
            feedbackUs: "Feedback geben",
            typeInAgain: "Geben Sie es erneut ein",
            volumeUp: "Lautstärke erhöhen",
            minimize: "Minimieren",
            maximize: "Maximieren",
            autoTranslate: "Automatische Übersetzung",
            on: "Ein",
            off: "Aus",
            currentLang: "Aktuelle Sprache : {lang}",
            languageSelection: "Meinen Standort verwenden",
            translatedTextDescription: "Amazon  diese Nachricht {from} -> {to} übersetzt hat.",
            save: "übersetzt hat",
            loadMore: "übersetzt hat",
            loading: "übersetzt hat...",
            chatDate: "Geschichte sprechen:",
            chatHistory: "Gesprächsverlauf",
            supportTeam: "Support-Team",
            searchChat: "Gespräche durchsuchen",
            noChatHistory: "Noch keine Gespräche",
            goback: "Gesprächsverlauf",
            noHistory: "Keine Geschichte...",
            close: "Schließen",
            createTicket: "Ticket erstellen",
            creatingTicketMsg: "Ticket wird erstellt...",
            createdTicketMsg: "Ticket erfolgreich erstellt!",
            deletingPersonalDataMsg: "Löschen aller persönlichen Daten...",
            deletedPersonalDataMsg: "Persönliche Daten erfolgreich gelöscht!",
            deleteKVVK: "Persönliche Daten löschen",
            ticketMode: "Ticket-Modus",
            nextStep: "Nächster Schritt",
            viewConversation: "Gespräch anzeigen",
            openRatingAgain: "Bewertung erneut öffnen  ",
            terrible: "Schrecklich",
            bad: "Schlecht",
            normal: "Normal",
            good: "Gut",
            wonderful: "Wunderbar",
            feedbackImportant: "Ihr Feedback ist uns wichtig!",
            feedbackThanksMessage: "Vielen Dank für Ihr Feedback!",
            withVideo: "Mit Video",
            withSound: "Mit Ton",
            download: "Herunterladen",
            representative: "Vertreter",
            vcCallingForScreen: "{userAgent}, ruft Sie für einen Videoanruf an...",
            vcCalling: "{userAgent}, Mit dir {medium} Will Videoanruf...",
            no: "Nein",
            didHelpful: "Hat Ihnen dieser Artikel geholfen?",
            howCanHelp: "Wie kann ich helfen?",
            offline: "Offline",
            city: "Stadt",
            district: "Bezirk",
            messageSent: "Nachricht gesendet",
            sendMessage: "Nachricht senden",
            noRepresentative:
                "Kein Vertreter verfügbar. Bitte hinterlassen Sie eine Nachricht und wir werden uns so schnell wie möglich bei Ihnen melden. ",
            and: "und",
            queueNumberDesc: `Du bist dran # {number}`,
            logWithSaved: "Mit gespeicherten Daten anmelden",
            differentUser: "Mit einem anderen Benutzer anmelden",
            waitRepresentative: "Warten auf Vertreter",
            isHelp: "{userAgent} hat es dir geholfen?",
            writePlaceHolder: "Nachricht schreiben…",
            messageTextPlaceHolder: "Nachricht",
            transcriptSending: "Transkript wird gesendet",
            transcriptSent: "Transkript erfolgreich gesendet",
            sendTranscript: "Transkript senden",
            sendAgainTranscript: "Transkript erneut senden",
            startChatAgain: "Chat erneut starten",
            lostConnection:
                "Ihre Verbindung ist unterbrochen. Bitte stellen Sie sicher, dass Sie eine Internetverbindung haben.",
            helpDesk: "Hilfe Schreibtisch",
            others: "Andere",
            you: "Sie",
            sureCloseChat: "Sind Sie sicher, dass Sie den Chat schließen möchten?",
            connectToLiveSupport: "Mit Live-Support verbinden",
            chatWithUs: "Chat mit uns",
            error: "Fehler",
            endChat: "Chat beenden",
            liveSup: "Live-Support",
            connLost: "Verbindung verloren",
            reConnect: "Erneut verbinden",
            evaluate: "Bewerten",
            cancel: "Stornieren",
            welcomeLiveSup: "Willkommen beim Live-Support",
            yes: "Ja",
            yourName: "Dein Name",
            yourEmail: "Deine E-Mail",
            phone: "Telefon",
            phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
            yourUsername: "Dein Benutzername",
            selectTopic: "Thema auswählen",
            connect: "Verbinden",
            topic: "Thema:",
            feedback: "Um Ihnen besser helfen zu können, geben Sie bitte Ihre Meinung ab...",
            rateConvo: "Bewerten Sie dieses Gespräch",
            reviewThank: "Vielen Dank für Ihre Bewertung!",
            seeYou: "Wir sehen uns!",
            name: "Name",
            email: "Email",
            username: "Benutzername",
            subject: "Betreff",
            pleaseWaitConnectUser: "Bitte warten Sie, während wir Sie mit einem Vertreter verbinden...",
            reconnecting: "Ihre Verbindung zum Server wurde unterbrochen, erneute Verbindung, bitte warten Sie...",
            connecting: "Verbindung zum Server, bitte warten Sie...",
            send: "Senden",
            descriptionPlaceHolder: "Sie können uns Feedback geben, indem Sie Ihre Vorschläge und Meinungen äußern.",
            messagePhone: "Bitte geben Sie Ihre Telefonnummer im entsprechenden Format ein.",
            visitorEmailIsNotValid: "Die eingegebene E-Mail-Adresse ist nicht korrekt",
            preferredResponseMethod: "Vorzugsmethode der Antwort",
            responseViaEmail: "Antwort per E-Mail",
            responseViaWhatsapp: "Antwort per WhatsApp"
        },
        chatbot: {
            preMenu: "vorheriges Menü",
            transferPreMenu: "Ich wechsle zum vorherigen Menü",
            liveSup: "Live Support",
            transferLiveSup: "Ich verbinde Sie zum Live-Support",
        },
        catalog: {
            catalog: "Katalog",
            searchPH: "Wonach suchen Sie?",
            allCategory: "Alle Kategorien",
            lastUpdate: "Letzte Aktualisierung",
            views: "Ansichten",
            reactionPrompt: "Hat Ihnen dieser Artikel geholfen?",
            thanks: "Danke",
            sendMessage: "Schreiben Sie uns",
        },
        shell: {
            searchResultCount: "{n} Ergebnisse",
            messagesSearch: "Nachrichten durchsuchen…",
            home: "Startseite", messages: "Nachrichten", help: "Hilfe",
            askTitle: "Frage stellen", askSubtitle: "Unser Bot und Team können helfen", continueChat: "Zurück zum letzten Gespräch",
            searchArticles: "Hilfeartikel durchsuchen", searchPlaceholder: "Artikel durchsuchen…", noArticles: "Noch keine Artikel",
            greeting: "Hallo! 👋", headline: "Wie können wir helfen?",
            noConversations: "Noch keine Gespräche", startNew: "Neues Gespräch starten", supportTeam: "Support-Team",
            loadFailed: "Nachrichten konnten nicht geladen werden",
            helpSearch: "Hilfe durchsuchen…", articleCount: "{n} Artikel", helpEmpty: "Keine Ergebnisse", startChat: "Chat starten", collections: "Sammlungen", articles: "Artikel", helpLoadFailed: "Inhalt konnte nicht geladen werden",
        },
        akinon: {
            chooseAddress: "Adresse auswählen",
            useMap: "Karte verwenden",
            selectCountry: "Land auswählen",
            country: "Land",
            send: "Schicken",
            selectCity: "Bezirk auswählen",
            city: "Bezirk",
            selectState: "Wählen Sie Ihre Stadt",
            state: "Provinz",
        },
        visitorLanguage: {
            rateTheMeting: "Bewerten Sie Ihr Treffen mit",
            rateTheEmptyMeting: "Would you like to rate the conversation?",
            confirmExperience: "Bewerten Sie Supsis Experience",
            addFile: "Datei hinzufügen",
            submitLocation: "Standort übermitteln",
            customerRepresentative: "Kunden Vertreter",
            emailAdress: "E-Mail-Addresse",
            send: "Schicken",
            evaluation: "Zur Auswertung",
            thankYouEvaluation: "wir danken Ihnen!",
            hasEmailError: "E-Mail falsch",
            reconnect: "Wieder verbinden",
            sendTheConversationToEmail: "Senden Sie das Gespräch an meine E-Mail",
            youDidNotAllowLocationAccess: "Sie haben den Standortzugriff nicht zugelassen!",
            allowLocationAccess: "Möchten Sie den Standortzugriff zulassen?",
            locationNotSupported: "Der Standortdienst wird in diesem Browser nicht unterstützt.",
            deleteConversation: "Sind Sie sicher, dass Sie alle Ihre Informationen löschen möchten?",
            endTheConversation: "Möchten Sie den Anruf wirklich beenden?",
            suggestionAndOpinion: "Geben Sie Ihre Vorschläge und Meinungen",
            suggestion: "Wir freuen uns über Ihre Anregungen und Meinungen.",
            skip: "Überspringen",
        },
    },
    fr: {
        message: {
            welcomeGreeting: "Bonjour ! Bienvenue 👋",
            welcomeStarting: "Démarrage du chat…",
            searchCountry: "Rechercher…",
            noResultFound: "Aucun résultat",
            welcomeCTA1: "Je souhaite des informations sur le produit.",
            welcomeCTA2: "J'ai une question technique.",
            welcomeCTA3: "Je souhaite un devis.",
            welcomeCardTitle: "Pouvons-nous mieux vous connaître ?",
            welcomeCardSubmit: "Envoyer",
            welcomeCardThanks: "Merci ! 🎉",
            welcomeFieldFullname: "Nom et prénom",
            welcomeFieldEmail: "Votre adresse e-mail",
            welcomeFieldPhone: "Votre numéro de téléphone",
            welcomeErrorPhone: "Ce numéro de téléphone ne semble pas valide",
            welcomePrecallHint: "Écrivez votre message…",
            welcomeComposerLocked: "Remplissez d'abord le formulaire ci-dessus",
            welcomeHintName: "Saisissez votre nom…",
            welcomeHintEmail: "Saisissez votre e-mail…",
            welcomeHintDefault: "Saisissez votre réponse…",
            welcomeAskName: "Pour commencer, quel est votre nom ?",
            welcomeAskEmail: "Merci ! Quelle est votre adresse e-mail ?",
            welcomeAskSubject: "Sur quel sujet puis-je vous aider ?",
            welcomeErrorRequired: "Ce champ ne peut pas rester vide — pouvez-vous réessayer ?",
            welcomeErrorEmail: "Cette adresse e-mail ne semble pas valide — pouvez-vous réessayer ?",
            welcomeErrorNumeric: "Seuls les chiffres sont acceptés ici — pouvez-vous réessayer ?",
            welcomeChooseAbove: "Choisissez une option ci-dessus",
            welcomeSkip: "Passer",
            welcomeSkipped: "Je passe pour l'instant",
            welcomeConsentAccept: "J'accepte",
            welcomeConsentAccepted: "J'accepte",
            welcomeStepContinue: "Continuer",
            back: "Retour",
            welcomeContinue: "Continuer",
            welcomeStart: "Démarrer le chat",
            closeChat: "Fermer le chat",
            speechTermination: "mettre fin à la conversation",
            You: "Vous",
            locationPermsNeeded: "Veuillez autoriser l'accès à votre emplacement pour continuer.",
            useMyLocation: "Utiliser mon emplacement",
            selectChatLang: "Sélectionnez la langue de chat",
            feedbackUs: "Nous donner votre avis",
            typeInAgain: "Tapez à nouveau",
            volumeUp: "Volume plus",
            minimize: "Minimiser",
            maximize: "Maximiser",
            autoTranslate: "Traduction automatique",
            on: "Sur",
            off: "De",
            currentLang: "Changer la langue parlée : {lang}",
            languageSelection: "Sélection de la langue",
            translatedTextDescription: "Amazon a traduit {from} -> {to} de ce message.",
            save: "Sauvegarder",
            loadMore: "Charger plus",
            loading: "Chargement...",
            chatDate: "Date",
            chatHistory: "Historique de chat",
            supportTeam: "Équipe support",
            searchChat: "Rechercher des conversations",
            noChatHistory: "Aucune conversation pour le moment",
            goback: "Retour",
            noHistory: "Aucun historique de chat",
            close: "Fermer",
            createTicket: "Créer un ticket",
            creatingTicketMsg: "Création du ticket ...",
            createdTicketMsg: "Ticket créé avec succès!",
            deletingPersonalDataMsg: "Suppression de toutes les données personnelles ...",
            deletedPersonalDataMsg: "Toutes les données personnelles ont été supprimées avec succès!",
            deleteKVVK: "Supprimer les données personnelles",
            ticketMode: "Mode ticket",
            nextStep: "Étape suivante",
            viewConversation: "Voir la conversation",
            openRatingAgain: "Activer la notation",
            terrible: "Terrible",
            bad: "Mauvais",
            normal: "Normal",
            good: "Bien",
            wonderful: "Merveilleux",
            feedbackImportant: "Votre avis est important pour nous",
            feedbackThanksMessage: "Merci pour votre avis.",
            withVideo: "Avec vidéo",
            withSound: "Avec son",
            download: "Télécharger",
            representative: "Représentant",
            vcCallingForScreen: "{userAgent}, Il veut voir votre écran...",
            vcCalling: "{userAgent}, Avec toi {medium} demandes de parole...",
            no: "Non",
            didHelpful: "Avez-vous trouvé cette réponse utile?",
            howCanHelp: "Comment puis-je vous aider?",
            offline: "Hors ligne",
            city: "Ville",
            district: "District",
            messageSent: "Votre message a été envoyé, nous vous répondrons par e-mail dans les plus brefs délais.",
            sendMessage: "envoyer le message",
            noRepresentative:
                "Aucun de nos agents n'est actif pour le moment. Souhaitez-vous que nous vous contactions par e-mail en transmettant votre message ? ",
            and: "et",
            queueNumberDesc: `À ton tour # {number}`,
            logWithSaved: "Vous pouvez vous connecter avec les informations que vous avez précédemment connectées.",
            differentUser: "compte différent",
            waitRepresentative: "Représentant attendu",
            isHelp: "{userAgent} ça t'a aidé ?",
            writePlaceHolder: "Écrivez un message…",
            messageTextPlaceHolder: "Message",
            transcriptSending: "Envoi de la transcription...",
            transcriptSent: "Transcription envoyée avec succès!",
            sendTranscript: "Envoyer la transcription",
            sendAgainTranscript: "Envoyer à nouveau la transcription",
            startChatAgain: "Commencer le chat à nouveau",
            lostConnection: "Votre connexion est interrompue. Assurez-vous d'avoir une connexion Internet.",
            helpDesk: "Service d'assistance",
            others: "Autres",
            you: "Vous",
            sureCloseChat: "Voulez-vous vraiment désactiver le chat ?",
            connectToLiveSupport: "Connectez-vous à l'assistance en direct",
            chatWithUs: "Discutez avec nous",
            error: "Erreur",
            endChat: "Terminer la conversation",
            liveSup: "Support en direct",
            connLost: "Votre connexion est interrompue. Assurez-vous d'avoir une connexion Internet.",
            reConnect: "Reconnecter",
            evaluate: "Évaluer",
            cancel: "Annuler",
            welcomeLiveSup: "Bienvenue au service d'aide en direct. Comment pouvons-nous vous aider?",
            yes: "Oui",
            yourName: "Votre nom",
            yourEmail: "Votre e-mail",
            phone: "Téléphone",
            phonePlaceholder: "Numéro de téléphone",
            yourUsername: "Votre nom d'utilisateur",
            selectTopic: "Sélectionnez un sujet",
            connect: "Connecter",
            topic: "Sujet:",
            feedback: "Afin de pouvoir mieux vous aider, merci de donner votre avis...",
            rateConvo: "Évaluer l'entretien",
            reviewThank: "Merci pour votre évaluation !",
            seeYou: "Votre feedback a de la valeur pour nous. À la prochaine!",
            name: "Nom",
            email: "E-mail",
            username: "Nom d'utilisateur",
            subject: "Sujet",
            pleaseWaitConnectUser:
                "Veuillez patienter, un de nos représentants sera connecté dès qu'il sera disponible",
            reconnecting: "Vous êtes déconnecté du serveur, reconnexion merci de patienter...",
            connecting: "Etablissement d'une connexion au serveur, veuillez patienter...",
            send: "Envoyer",
            descriptionPlaceHolder:
                "Vous pouvez nous faire part de vos commentaires en indiquant vos suggestions et opinions.",
            messagePhone: " Veuillez entrer votre numéro de téléphone dans le format approprié.",
            visitorEmailIsNotValid: "L'adresse e-mail que vous avez saisie n'est pas correcte",
            preferredResponseMethod: "Méthode de réponse préférée",
            responseViaEmail: "Réponse par e-mail",
            responseViaWhatsapp: "Réponse par WhatsApp"
        },
        chatbot: {
            preMenu: "menu précédent",
            transferPreMenu: "Je passe au menu précédent",
            liveSup: "Support en direct",
            transferLiveSup: "Je vous transfère au support en direct",
        },
        catalog: {
            catalog: "Catalogue",
            searchPH: "Rechercher des réponses",
            allCategory: "toutes catégories",
            lastUpdate: "Dernière mise à jour",
            views: "Vues",
            reactionPrompt: "Cet article vous a-t-il aidé ?",
            thanks: "Merci",
            sendMessage: "Envoyez-nous un message",
        },
        shell: {
            searchResultCount: "{n} résultats",
            messagesSearch: "Rechercher dans les messages…",
            home: "Accueil", messages: "Messages", help: "Aide",
            askTitle: "Poser une question", askSubtitle: "Notre bot et notre équipe peuvent vous aider", continueChat: "Retour à la dernière conversation",
            searchArticles: "Rechercher des articles d'aide", searchPlaceholder: "Rechercher des articles…", noArticles: "Aucun article pour le moment",
            greeting: "Bonjour ! 👋", headline: "Comment pouvons-nous vous aider ?",
            noConversations: "Aucune conversation pour le moment", startNew: "Démarrer une nouvelle conversation", supportTeam: "Équipe d'assistance",
            loadFailed: "Impossible de charger les messages",
            helpSearch: "Rechercher dans l'aide…", articleCount: "{n} articles", helpEmpty: "Aucun résultat", startChat: "Démarrer une discussion", collections: "Collections", articles: "Articles", helpLoadFailed: "Impossible de charger le contenu",
        },
        akinon: {
            chooseAddress: "Sélectionnez l'adresse",
            useMap: "Utiliser la carte",
            selectCountry: "Choisissez le pays",
            country: "Pays",
            send: "Envoyer",
            selectCity: "Sélectionnez la ville",
            city: "Ville",
            selectState: "Sélectionnez l'état",
            state: "État",
        },
        visitorLanguage: {
            rateTheMeting: "évaluez votre rencontre avec",
            rateTheEmptyMeting: "Would you like to rate the conversation?",
            confirmExperience: "Évaluez l'expérience Supsis",
            addFile: "Ajouter le fichier",
            submitLocation: "Envoyer emplacement",
            customerRepresentative: "Représentant de la clientèle",
            emailAdress: "Adresse e-mail",
            send: "Envoyer",
            evaluation: "Pour évaluation",
            thankYouEvaluation: "Nous te remercions!",
            hasEmailError: "E-mail incorrect",
            reconnect: "Se reconnecter",
            sendTheConversationToEmail: "Envoyer la conversation sur mon e-mail",
            youDidNotAllowLocationAccess: "Vous n'avez pas autorisé l'accès à la position!",
            allowLocationAccess: "Voulez-vous autoriser l'accès à la position?",
            locationNotSupported: "Le service de localisation n'est pas pris en charge dans ce navigateur.",
            deleteConversation: "Êtes-vous sûr de vouloir supprimer toutes vos informations?",
            endTheConversation: "Voulez-vous vraiment mettre fin à l'appel?",
            suggestionAndOpinion: "Donnez vos suggestions et avis",
            suggestion: "Nous aimerions recevoir vos suggestions et opinions.",
            skip: "Sauter",
        },
    },
    es: {
        message: {
            welcomeGreeting: "¡Hola! Te damos la bienvenida 👋",
            welcomeStarting: "Iniciando el chat…",
            searchCountry: "Buscar…",
            noResultFound: "No se encontraron resultados",
            welcomeCTA1: "Quiero información sobre el producto.",
            welcomeCTA2: "Tengo una pregunta técnica.",
            welcomeCTA3: "Quiero un presupuesto.",
            welcomeCardTitle: "¿Podemos conocerle mejor?",
            welcomeCardSubmit: "Enviar",
            welcomeCardThanks: "¡Gracias! 🎉",
            welcomeFieldFullname: "Nombre y apellidos",
            welcomeFieldEmail: "Su dirección de correo",
            welcomeFieldPhone: "Su número de teléfono",
            welcomeErrorPhone: "Ese número de teléfono no parece válido",
            welcomePrecallHint: "Escriba su mensaje…",
            welcomeComposerLocked: "Primero complete el formulario de arriba",
            welcomeHintName: "Escribe tu nombre…",
            welcomeHintEmail: "Escribe tu correo…",
            welcomeHintDefault: "Escribe tu respuesta…",
            welcomeAskName: "Para empezar, ¿cuál es tu nombre?",
            welcomeAskEmail: "¡Gracias! ¿Cuál es tu correo electrónico?",
            welcomeAskSubject: "¿En qué puedo ayudarte?",
            welcomeErrorRequired: "No podemos dejar este campo vacío, ¿lo intentas de nuevo?",
            welcomeErrorEmail: "Ese correo no parece válido, ¿lo intentas de nuevo?",
            welcomeErrorNumeric: "Aquí solo puedes escribir números, ¿lo intentas de nuevo?",
            welcomeChooseAbove: "Elige una opción arriba",
            welcomeSkip: "Omitir",
            welcomeSkipped: "Lo omito por ahora",
            welcomeConsentAccept: "Acepto",
            welcomeConsentAccepted: "Acepto",
            welcomeStepContinue: "Continuar",
            back: "Atrás",
            welcomeContinue: "Continuar",
            welcomeStart: "Iniciar chat",
            speechTermination: "finalizar conversación",
            You: "Usted",
            closeChat: "Cerrar chat",
            locationPermsNeeded: "Necesitamos permisos de ubicación para continuar.",
            useMyLocation: "Usar mi ubicación",
            selectChatLang: "Seleccionar idioma de chat",
            feedbackUs: "Danos tu opinión",
            typeInAgain: "Escriba de nuevo",
            volumeUp: "Subir volumen",
            minimize: "Minimizar",
            maximize: "Maximizar",
            autoTranslate: "Traducción automática",
            on: "Encendido",
            off: "Apagado",
            currentLang: "Cambiar el idioma del habla: {lang}",
            languageSelection: "Selección de idioma",
            translatedTextDescription: "Amazon este mensaje {from} -> {to} hizo la traducción.",
            save: "Guardar",
            loadMore: "Cargar más",
            loading: "Cargando...",
            chatDate: "Fecha de la charla: ",
            chatHistory: "Historial de conversación",
            supportTeam: "Equipo de soporte",
            searchChat: "Buscar conversaciones",
            noChatHistory: "Aún no hay conversaciones",
            goback: "Volver",
            noHistory: "No se ha encontrado el historial de conversaciones...",
            close: "Cerrar",
            createTicket: "Crear ticket",
            creatingTicketMsg: "Creando ticket...",
            createdTicketMsg: "Ticket creado con éxito!",
            deletingPersonalDataMsg: "Borrando todos los datos personales...",
            deletedPersonalDataMsg: "Todos los datos personales se han eliminado con éxito!",
            deleteKVVK: "Eliminar toda mi información",
            ticketMode: "Modo de ticket",
            nextStep: "Cuál es tu próximo paso?",
            viewConversation: "Ver conversación",
            openRatingAgain: "Calificación abierta  ",
            terrible: "Terrible",
            bad: "Malo",
            normal: "Normal",
            good: "Bueno",
            wonderful: "Maravilloso",
            feedbackImportant: "Tu opinión es importante para nosotros",
            feedbackThanksMessage: "Gracias por tu opinión",
            withVideo: "Con video",
            withSound: "Con sonido",
            download: "Descargar",
            representative: "Representante",
            vcCallingForScreen: "{userAgent}, Quiere ver tu pantalla...",
            vcCalling: "{userAgent}, Contigo {medium} pide hablar...",
            no: "No",
            didHelpful: "Fue útil el contenido?",
            howCanHelp: "Cómo puedo ayudarte?",
            offline: "Desconectado",
            city: "Ciudad",
            district: "Distrito",
            messageSent:
                "Su mensaje ha sido enviado, nos pondremos en contacto con usted por correo electrónico lo antes posible.",
            sendMessage: "Enviar mensaje",
            noRepresentative:
                "Ninguno de nuestros agentes está activo en este momento. ¿Quiere que le contactemos por correo electrónico reenviando su mensaje? ",
            and: "y",
            queueNumberDesc: `Tu turno # {number}`,
            logWithSaved: "Puede conectarse con la información que conectó anteriormente.",
            differentUser: "cuenta diferente",
            waitRepresentative: "Representante esperado",
            isHelp: "{userAgent} te ayudó?",
            writePlaceHolder: "Escribe un mensaje…",
            messageTextPlaceHolder: "Mensaje",
            transcriptSending: "Enviando",
            transcriptSent: "Copia enviada",
            sendTranscript: "Enviar conversación a mi correo electrónico",
            sendAgainTranscript: "Enviar conversación a mi correo electrónico",
            startChatAgain: "Reconectar",
            lostConnection: "Tu conexión está rota. Por favor, asegúrese de tener una conexión a Internet.",
            helpDesk: "Aplicación de soporte en vivo",
            others: "Otros",
            you: "Tú",
            sureCloseChat: "Seguro que quieres desactivar el chat?",
            connectToLiveSupport: "Conéctese al soporte en vivo",
            chatWithUs: "Chatea con nosotros",
            error: "Error",
            endChat: "Chat finalizado",
            liveSup: "Soporte en vivo",
            connLost: "Tu conexión está rota. Por favor, asegúrese de tener una conexión a Internet.",
            reConnect: "Reconectar",
            evaluate: "Evaluar",
            cancel: "Cancelar",
            welcomeLiveSup: "Bienvenido al servicio de ayuda en vivo. como podemos ayudarte?",
            yes: "Sí",
            yourName: "Tu nombre",
            yourEmail: "Dirección de correo electrónico",
            phone: "Teléfono",
            phonePlaceholder: "Ingrese su número de teléfono",
            yourUsername: "Nombre de usuario",
            selectTopic: "Seleccionar tema",
            connect: "Conectar",
            topic: "Sujeto:",
            feedback: "Para poder ayudarte mejor, por favor da tu opinión...",
            rateConvo: "Evaluar la entrevista",
            reviewThank: "Gracias por tu evaluación!",
            seeYou: "Su opinión es valiosa para nosotros. ¡Hasta luego!",
            name: "Nombre",
            email: "Dirección de correo electrónico",
            username: "Nombre de usuario",
            subject: "Sujeto",
            pleaseWaitConnectUser: "Espere, uno de nuestros representantes se conectará cuando esté disponible.",
            reconnecting: "Estás desconectado del servidor, reconectando por favor espera...",
            connecting: "Estableciendo una conexión con el servidor, por favor espere...",
            send: "Enviar",
            descriptionPlaceHolder: "Puede darnos su opinión indicando sus sugerencias y opiniones.",
            messagePhone: "Ingrese su número de teléfono en el formato apropiado.",
            visitorEmailIsNotValid: "La dirección de correo electrónico que ingresó no es correcta",
            preferredResponseMethod: "Método de respuesta preferido",
            responseViaEmail: "Respuesta por correo electrónico",
            responseViaWhatsapp: "Respuesta por WhatsApp"
        },
        chatbot: {
            preMenu: "menú anterior",
            transferPreMenu: "Paso al menú anterior",
            liveSup: "Soporte vital",
            transferLiveSup: "Te estoy transfiriendo a soporte en vivo",
        },
        catalog: {
            catalog: "Catálogo",
            searchPH: "Buscar respuestas",
            allCategory: "todas las categorias",
            lastUpdate: "Última actualización",
            views: "Puntos de vista",
            reactionPrompt: "¿Le ayudó este artículo?",
            thanks: "Gracias",
            sendMessage: "Envíenos un mensaje",
        },
        shell: {
            searchResultCount: "{n} resultados",
            messagesSearch: "Buscar en los mensajes…",
            home: "Inicio", messages: "Mensajes", help: "Ayuda",
            askTitle: "Hacer una pregunta", askSubtitle: "Nuestro bot y equipo pueden ayudar", continueChat: "Volver a la última conversación",
            searchArticles: "Buscar artículos de ayuda", searchPlaceholder: "Buscar artículos…", noArticles: "Aún no hay artículos",
            greeting: "¡Hola! 👋", headline: "¿Cómo podemos ayudarte?",
            noConversations: "Aún no hay conversaciones", startNew: "Iniciar una nueva conversación", supportTeam: "Equipo de soporte",
            loadFailed: "No se pudieron cargar los mensajes",
            helpSearch: "Buscar en la ayuda…", articleCount: "{n} artículos", helpEmpty: "Sin resultados", startChat: "Iniciar chat", collections: "Colecciones", articles: "Artículos", helpLoadFailed: "No se pudo cargar el contenido",
        },
        akinon: {
            chooseAddress: "Dirección de entrega",
            useMap: "Usar mapa",
            selectCountry: "País Seleccionar",
            country: "País",
            send: "Enviar",
            selectCity: "Ciudad Seleccionar",
            city: "Ciudad",
            selectState: "Estado Seleccionar",
            state: "Estado",
        },
        visitorLanguage: {
            rateTheMeting: "califica tu encuentro con",
            rateTheEmptyMeting: "Would you like to rate the conversation?",
            confirmExperience: "Califica Experiencia Supsis",
            addFile: "Agregar archivo",
            submitLocation: "Enviar ubicación",
            customerRepresentative: "Representante del cliente",
            emailAdress: "Dirección de correo electrónico",
            send: "Enviar",
            evaluation: "Para evaluar",
            thankYouEvaluation: "¡te agradecemos!",
            hasEmailError: "Correo electrónico incorrecto",
            reconnect: "Reconectar",
            sendTheConversationToEmail: "Enviar la conversación a mi correo electrónico.",
            youDidNotAllowLocationAccess: "No permitiste el acceso a la ubicación!",
            allowLocationAccess: "Quieres permitir el acceso a la ubicación?",
            locationNotSupported: "El servicio de ubicación no es compatible con este navegador.",
            deleteConversation: "Está seguro de que desea eliminar toda su información?",
            endTheConversation: "Está seguro de que desea finalizar la llamada?",
            suggestionAndOpinion: "Dé sus sugerencias y opiniones",
            suggestion: "Nos gustaría recibir vuestras sugerencias y opiniones.",
            skip: "Omitir",
        },
    },
    ar: {
        message: {
            welcomeGreeting: "مرحبًا! أهلًا بك 👋",
            welcomeStarting: "جارٍ بدء المحادثة…",
            searchCountry: "بحث…",
            noResultFound: "لا توجد نتائج",
            welcomeCTA1: "أرغب في معلومات عن المنتج.",
            welcomeCTA2: "لدي سؤال تقني.",
            welcomeCTA3: "أرغب في عرض سعر.",
            welcomeCardTitle: "هل يمكننا التعرف عليك أكثر؟",
            welcomeCardSubmit: "إرسال",
            welcomeCardThanks: "شكراً لك! 🎉",
            welcomeFieldFullname: "الاسم الكامل",
            welcomeFieldEmail: "بريدك الإلكتروني",
            welcomeFieldPhone: "رقم هاتفك",
            welcomeErrorPhone: "رقم الهاتف لا يبدو صالحاً",
            welcomePrecallHint: "اكتب رسالتك…",
            welcomeComposerLocked: "يرجى ملء النموذج أعلاه أولاً",
            welcomeHintName: "اكتب اسمك…",
            welcomeHintEmail: "اكتب بريدك الإلكتروني…",
            welcomeHintDefault: "اكتب إجابتك…",
            welcomeAskName: "بدايةً، ما اسمك؟",
            welcomeAskEmail: "شكرًا! ما هو بريدك الإلكتروني؟",
            welcomeAskSubject: "بماذا يمكنني مساعدتك؟",
            welcomeErrorRequired: "لا يمكن ترك هذا الحقل فارغًا، هل تحاول مرة أخرى؟",
            welcomeErrorEmail: "يبدو أن هذا البريد غير صالح، هل تحاول مرة أخرى؟",
            welcomeErrorNumeric: "يمكنك إدخال أرقام فقط هنا، هل تحاول مرة أخرى؟",
            welcomeChooseAbove: "اختر خيارًا من الأعلى",
            welcomeSkip: "تخطٍّ",
            welcomeSkipped: "سأتخطى هذا الآن",
            welcomeConsentAccept: "أوافق",
            welcomeConsentAccepted: "أوافق",
            welcomeStepContinue: "متابعة",
            back: "رجوع",
            welcomeContinue: "متابعة",
            welcomeStart: "ابدأ المحادثة",
            closeChat: "إغلاق الدردشة",
            speechTermination: "إنهاء المحادثة",
            You: "أنت",
            locationPermsNeeded: "من فضلك قم بتفعيل خدمة الموقع للمتابعة",
            useMyLocation: "استخدم موقعي",
            selectChatLang: "اختر لغة الدردشة",
            feedbackUs: "تقييم الدردشة",
            typeInAgain: "اكتب مرة أخرى",
            volumeUp: "رفع الصوت",
            minimize: "تصغير",
            maximize: "تكبير",
            autoTranslate: "ترجمة تلقائية",
            on: "مفعل",
            off: "معطل",
            currentLang: "تغيير لغة الكلام: {lang}",
            languageSelection: "اختيار اللغة",
            translatedTextDescription: "قامت Amazon بترجمة {from} -> {to} من هذه الرسالة.",
            save: "حفظ",
            loadMore: "تحميل المزيد",
            loading: "جاري التحميل",
            chatDate: "تاريخ الدردشة",
            chatHistory: "تاريخ الدردشة",
            supportTeam: "فريق الدعم",
            searchChat: "البحث في المحادثات",
            noChatHistory: "لا توجد محادثات بعد",
            goback: "العودة",
            noHistory: "لا يوجد تاريخ",
            close: "إغلاق",
            createTicket: "إنشاء تذكرة",
            creatingTicketMsg: "جاري إنشاء التذكرة ...",
            createdTicketMsg: "تم إنشاء التذكرة بنجاح!",
            deletingPersonalDataMsg: "جاري حذف جميع البيانات الشخصية ...",
            deletedPersonalDataMsg: "تم حذف جميع البيانات الشخصية بنجاح!",
            deleteKVVK: "حذف جميع البيانات الشخصية",
            ticketMode: "وضع التذكرة",
            nextStep: "الخطوة التالية",
            viewConversation: "عرض المحادثة",
            openRatingAgain: "افتح التقييم مرة أخرى",
            terrible: "فظيع",
            bad: "سيئ",
            normal: "عادي",
            good: "جيد",
            wonderful: "رائع",
            feedbackImportant: "ملاحظاتك مهمة بالنسبة لنا",
            feedbackThanksMessage: "شكرا لك على ملاحظاتك!",
            withVideo: "مع فيديو",
            withSound: "مع صوت",
            download: "تحميل",
            representative: "ممثل",
            vcCallingForScreen: "يريد {userAgent} رؤية شاشتك ...",
            vcCalling: "يطلب {userAgent} التحدث معك {medium} ...",
            no: "لا",
            didHelpful: "هل كانت هذه المحادثة مفيدة؟",
            howCanHelp: "كيف يمكنني مساعدتك؟",
            offline: "غير متصل",
            city: "مدينة",
            district: "منطقة",
            messageSent: "تم إرسال رسالتك وسنعاود الاتصال بك عبر البريد الإلكتروني في أقرب وقت ممكن.",
            sendMessage: "إرسال رسالة",
            noRepresentative:
                "لا أحد من وكلائنا نشط في الوقت الحالي. هل تود أن نتواصل معك عبر البريد الإلكتروني عن طريق إعادة توجيه رسالتك؟ ",
            and: "و",
            queueNumberDesc: `قائمة الانتظار # {number}`,
            logWithSaved: "تسجيل الدخول باستخدام البريد الإلكتروني المحفوظ",
            differentUser: "تسجيل الدخول باستخدام بريد إلكتروني مختلف",
            waitRepresentative: "يرجى الانتظار حتى يتم توجيهك إلى وكيل",
            isHelp: "هل ساعدك {userAgent}؟",
            writePlaceHolder: "اكتب رسالتك…",
            messageTextPlaceHolder: "رسالة",
            transcriptSending: "إرسال",
            transcriptSent: "تم إرسال النسخ",
            sendTranscript: "إرسال نسخة من هذه المحادثة إلى بريدك الإلكتروني",
            sendAgainTranscript: "إعادة إرسال المحادثة إلى بريدي الإلكتروني",
            startChatAgain: "أعد الاتصال",
            lostConnection: "اتصالك مقطوع. من فضلك تأكد من أن لديك اتصال بالإنترنت.",
            helpDesk: "مكتب المساعدة",
            others: "آخرين",
            you: "أنت",
            sureCloseChat: "هل أنت متأكد من أنك تريد إغلاق الدردشة؟",
            connectToLiveSupport: "الاتصال بالدعم المباشر",
            chatWithUs: "دردش معنا",
            error: "خطأ",
            endChat: "إنهاء الدردشة",
            liveSup: "الدعم المباشر",
            connLost: "اتصال مقطوع",
            reConnect: "إعادة الاتصال",
            evaluate: "تقييم",
            cancel: "إلغاء",
            welcomeLiveSup: "مرحبا بكم في خدمة المساعدة الحية. كيف يمكننا مساعدتك؟",
            yes: "نعم",
            yourName: "اسمك",
            yourEmail: "بريدك الإلكتروني",
            phone: "هاتف",
            phonePlaceholder: "الرجاء إدخال رقم الهاتف",
            yourUsername: "اسم المستخدم",
            selectTopic: "حدد الموضوع",
            connect: "الاتصال",
            topic: "موضوع:",
            feedback: "لكي تكون قادرًا على مساعدتك بشكل أفضل ، يرجى إبداء رأيك ...",
            rateConvo: "تقييم المقابلة",
            reviewThank: "شكرا لتقييمك!",
            seeYou: "ردود الفعل الخاص بك هو قيمة بالنسبة لنا. نراكم مرة أخرى!",
            name: "اسم",
            email: "عنوان البريد الالكتروني",
            username: "اسم المستخدم",
            subject: "موضوع",
            pleaseWaitConnectUser: "يرجى الانتظار ، سيتم الاتصال بأحد ممثلينا عند توفره",
            reconnecting: "أنت غير متصل بالخادم ، جاري إعادة الاتصال ، يرجى الانتظار ...",
            connecting: "جاري إنشاء اتصال بالخادم ، الرجاء الانتظار ...",
            send: "يرسل",
            descriptionPlaceHolder: "يمكنك تزويدنا بآرائك من خلال إبداء اقتراحاتك وآرائك.",
            messagePhone: "الرجاء إدخال رقم هاتفك بالتنسيق المناسب.",
            visitorEmailIsNotValid: "عنوان البريد الإلكتروني الذي أدخلته غير صحيح",
            preferredResponseMethod: "طريقة الاستجابة المفضلة",
            responseViaEmail: "الاستجابة بالبريد الإلكتروني",
            responseViaWhatsapp: "الاستجابة بواسطة WhatsApp"
        },
        chatbot: {
            preMenu: "القائمة السابقة",
            transferPreMenu: "أنقل إلى القائمة السابقة",
            liveSup: "دعم مباشر",
            transferLiveSup: "أنا أقوم بتحويلك إلى الدعم المباشر",
        },
        catalog: {
            catalog: "فهرس",
            searchPH: "ابحث عن أجوبة",
            allCategory: "جميع الفئات",
            lastUpdate: "اخر تحديث",
            views: "الآراء",
            reactionPrompt: "هل ساعدتك هذه المقالة؟",
            thanks: "شكرا لك",
            sendMessage: "راسلنا",
        },
        shell: {
            searchResultCount: "{n} نتيجة",
            messagesSearch: "ابحث في الرسائل…",
            home: "الرئيسية", messages: "الرسائل", help: "المساعدة",
            askTitle: "اطرح سؤالاً", askSubtitle: "يمكن لروبوتنا وفريقنا المساعدة", continueChat: "العودة إلى المحادثة الأخيرة",
            searchArticles: "ابحث في مقالات المساعدة", searchPlaceholder: "ابحث في المقالات…", noArticles: "لا توجد مقالات بعد",
            greeting: "مرحباً! 👋", headline: "كيف يمكننا مساعدتك؟",
            noConversations: "لا توجد محادثات بعد", startNew: "بدء محادثة جديدة", supportTeam: "فريق الدعم",
            loadFailed: "تعذر تحميل الرسائل",
            helpSearch: "ابحث في المساعدة…", articleCount: "{n} مقالة", helpEmpty: "لا توجد نتائج", startChat: "ابدأ محادثة", collections: "المجموعات", articles: "المقالات", helpLoadFailed: "تعذر تحميل المحتوى",
        },
        akinon: {
            chooseAddress: "حدد العنوان",
            useMap: "استخدم الخريطة",
            selectCountry: "حدد الدولة",
            country: "بلد",
            send: "يرسل",
            selectCity: "حدد المدينة",
            city: "مدينة",
            selectState: "حدد الدولة",
            state: "حالة",
        },
        visitorLanguage: {
            rateTheMeting: "قيم لقائك مع",
            rateTheEmptyMeting: "Would you like to rate the conversation?",
            confirmExperience: "قيم تجربة Supsis",
            addFile: "إضافة ملف",
            submitLocation: "إرسال الموقع",
            customerRepresentative: "ممثل خدمة العملاء",
            emailAdress: "عنوان البريد الالكتروني",
            send: "يرسل",
            evaluation: "للتقييم",
            thankYouEvaluation: "نشكركم!",
            hasEmailError: "البريد الإلكتروني غير صحيح",
            reconnect: "أعد الاتصال",
            sendTheConversationToEmail: "أرسل المحادثة إلى بريدي الإلكتروني",
            youDidNotAllowLocationAccess: "أنت لم تسمح بالوصول إلى الموقع!",
            allowLocationAccess: "هل تريد السماح للوصول إلى الموقع؟",
            locationNotSupported: "خدمة الموقع غير مدعومة في هذا المتصفح.",
            deleteConversation: "هل أنت متأكد أنك تريد حذف جميع المعلومات الخاصة بك؟",
            endTheConversation: "هل أنت متأكد أنك تريد إنهاء المكالمة؟",
            suggestionAndOpinion: "قدم اقتراحاتك وآرائك",
            suggestion: "ونود أن نتلقى اقتراحاتكم وآرائكم.",
            skip: "تخطى",
        },
    },
    it: {
        message: {
            welcomeGreeting: "Ciao! Benvenuto 👋",
            welcomeStarting: "Avvio della chat…",
            searchCountry: "Cerca…",
            noResultFound: "Nessun risultato",
            welcomeCTA1: "Vorrei informazioni sul prodotto.",
            welcomeCTA2: "Ho una domanda tecnica.",
            welcomeCTA3: "Vorrei un preventivo.",
            welcomeCardTitle: "Possiamo conoscerti meglio?",
            welcomeCardSubmit: "Invia",
            welcomeCardThanks: "Grazie! 🎉",
            welcomeFieldFullname: "Nome e cognome",
            welcomeFieldEmail: "Il tuo indirizzo email",
            welcomeFieldPhone: "Il tuo numero di telefono",
            welcomeErrorPhone: "Questo numero di telefono non sembra valido",
            welcomePrecallHint: "Scrivi il tuo messaggio…",
            welcomeComposerLocked: "Compila prima il modulo qui sopra",
            welcomeHintName: "Scrivi il tuo nome…",
            welcomeHintEmail: "Scrivi la tua e-mail…",
            welcomeHintDefault: "Scrivi la tua risposta…",
            welcomeAskName: "Per iniziare, come ti chiami?",
            welcomeAskEmail: "Grazie! Qual è il tuo indirizzo e-mail?",
            welcomeAskSubject: "Su cosa posso aiutarti?",
            welcomeErrorRequired: "Questo campo non può restare vuoto: puoi riprovare?",
            welcomeErrorEmail: "Questa e-mail non sembra valida: puoi riprovare?",
            welcomeErrorNumeric: "Qui puoi inserire solo numeri: puoi riprovare?",
            welcomeChooseAbove: "Scegli un'opzione qui sopra",
            welcomeSkip: "Salta",
            welcomeSkipped: "Per ora salto",
            welcomeConsentAccept: "Accetto",
            welcomeConsentAccepted: "Accetto",
            welcomeStepContinue: "Continua",
            back: "Indietro",
            welcomeContinue: "Continua",
            welcomeStart: "Inizia la chat",
            closeChat: "Chiudi la chat",
            speechTermination: "Termina la conversazione",
            You: "Lei",
            locationPermsNeeded: "È necessario il permesso per la posizione per utilizzare questa funzionalità",
            useMyLocation: "Usa la mia posizione",
            selectChatLang: "Seleziona la lingua della chat",
            feedbackUs: "Mi dispiace, non ti ho capito.",
            typeInAgain: "Riprova a digitare.",
            volumeUp: "Aumenta il volume",
            minimize: "Minimizza",
            maximize: "Ingrandisci",
            autoTranslate: "Traduzione automatica",
            on: "Attivo",
            off: "Disattivo",
            currentLang: "Cambia lingua della chat: {lang}",
            languageSelection: "Selezione della lingua",
            translatedTextDescription: "Amazon ha tradotto questo messaggio da {from} a {to}.",
            translatedInfoTextDescription: "SUPSIS ha tradotto questo messaggio da {from} a {to}.",
            save: "Salva",
            loadMore: "Carica altro",
            loading: "Caricamento in corso...",
            chatDate: "Data della chat: ",
            chatHistory: "Cronologia della chat",
            supportTeam: "Team di supporto",
            searchChat: "Cerca conversazioni",
            noChatHistory: "Nessuna conversazione ancora",
            goback: "Torna indietro",
            noHistory: "Nessuna cronologia di chat trovata...",
            close: "Chiudi",
            createTicket: "Lascia un messaggio",
            creatingTicketMsg: "Creazione del ticket in corso...",
            createdTicketMsg: "Ticket creato con successo!",
            deletingPersonalDataMsg: "Eliminazione dei dati personali in corso...",
            deletedPersonalDataMsg: "Dati personali eliminati con successo!",
            deleteKVVK: "Elimina tutti i miei dati",
            ticketMode: "Invia un messaggio al ticket",
            nextStep: "Qual è il tuo prossimo passo?",
            viewConversation: "Visualizza la conversazione",
            openRatingAgain: "Apri di nuovo la valutazione",
            terrible: "Terribile",
            bad: "Scadente",
            normal: "Normale",
            good: "Buono",
            wonderful: "Meraviglioso",
            feedbackImportant: "Il tuo feedback è importante per noi.",
            feedbackThanksMessage: "Grazie per il tuo feedback.",
            withVideo: "Con video",
            withSound: "Con audio",
            download: "Scarica il file",
            representative: "Rappresentante",
            vcCallingForScreen: "{userAgent} vuole vedere il tuo schermo...",
            vcCalling: "{userAgent} richiede una conversazione {medium} con te...",
            no: "No",
            didHelpful: "Il contenuto è stato utile?",
            howCanHelp: "Come posso aiutarti?",
            offline: "Offline",
            city: "Città",
            district: "Distretto",
            messageSent: "Il tuo messaggio è stato inviato. Ti risponderemo via email al più presto.",
            sendMessage: "Invia messaggio",
            noRepresentative:
                "Al momento non abbiamo rappresentanti disponibili. Desideri inviare il tuo messaggio per essere contattato tramite email?",
            and: "e",
            queueNumberDesc: "Il tuo numero in coda è # {number}",
            logWithSaved: "Puoi accedere con le tue credenziali salvate.",
            differentUser: "Utente diverso",
            waitRepresentative: "In attesa di un rappresentante",
            isHelp: "{userAgent} ti ha aiutato?",
            writePlaceHolder: "Scrivi un messaggio…",
            messageTextPlaceHolder: "Messaggio",
            transcriptSending: "Invio in corso",
            transcriptSent: "Copia inviata",
            sendTranscript: "Invia la conversazione via email",
            sendAgainTranscript: "Invia nuovamente la conversazione via email",
            startChatAgain: "Riconnetti",
            lostConnection: "Connessione persa. Assicurati di avere una connessione Internet attiva.",
            helpDesk: "App di supporto live",
            others: "Altri",
            you: "Tu",
            sureCloseChat: "Sei sicuro di voler chiudere la chat?",
            connectToLiveSupport: "Connetti al supporto live",
            chatWithUs: "Chatta con noi",
            error: "Errore",
            endChat: "Termina la chat",
            liveSup: "Supporto live",
            connLost: "Connessione persa. Assicurati di avere una connessione Internet attiva.",
            reConnect: "Riconnetti",
            evaluate: "Valuta",
            cancel: "Annulla",
            welcomeLiveSup: "Benvenuto nel servizio di assistenza live. Come posso aiutarti?",
            yes: "Sì",
            yourName: "Il tuo nome",
            yourEmail: "La tua email",
            phone: "Telefono",
            phonePlaceholder: "Inserisci il tuo numero di telefono",
            yourUsername: "Il tuo nome utente",
            selectTopic: "Seleziona un argomento",
            connect: "CONNETTI",
            topic: "Argomento:",
            feedback: "Fornisci suggerimenti e commenti per aiutarci a migliorare...",
            rateConvo: "Valuta la conversazione",
            reviewThank: "Grazie per la tua valutazione!",
            seeYou: "Il tuo feedback è prezioso per noi. A presto!",
            name: "Nome",
            email: "Indirizzo email",
            username: "Nome utente",
            subject: "Oggetto",
            pleaseWaitConnectUser: "Attendi, verrai connesso quando un rappresentante sarà disponibile",
            reconnecting: "Connessione persa, riconnessione in corso, per favore attendi...",
            connecting: "Connessione in corso, per favore attendi...",
            send: "Invia",
            descriptionPlaceHolder: "Fornisci suggerimenti e commenti per aiutarci a migliorare.",
            messagePhone: "Inserisci il tuo numero di telefono in un formato corretto.",
            visitorEmailIsNotValid: "L'indirizzo email inserito non è valido",
            preferredResponseMethod: "Metodo di risposta preferito",
            responseViaEmail: "Risposta via email",
            responseViaWhatsapp: "Risposta via WhatsApp"
        },
        chatbot: {
            preMenu: "Pre Menu",
            transferPreMenu: "Passo al menu precedente",
            liveSup: "Supporto dal vivo",
            transferLiveSup: "Ti sto trasferendo al supporto dal vivo",
        },
        catalog: {
            catalog: "Catalogo",
            searchPH: "Cerca",
            allCategory: "Tutte le categorie",
            lastUpdate: "Ultimo aggiornamento",
            views: "Visualizzazioni",
            reactionPrompt: "Questo articolo ti è stato utile?",
            thanks: "Grazie",
            sendMessage: "Scrivici",
        },
        shell: {
            searchResultCount: "{n} risultati",
            messagesSearch: "Cerca nei messaggi…",
            home: "Home", messages: "Messaggi", help: "Aiuto",
            askTitle: "Fai una domanda", askSubtitle: "Il nostro bot e il nostro team possono aiutarti", continueChat: "Torna all'ultima conversazione",
            searchArticles: "Cerca articoli di aiuto", searchPlaceholder: "Cerca articoli…", noArticles: "Ancora nessun articolo",
            greeting: "Ciao! 👋", headline: "Come possiamo aiutarti?",
            noConversations: "Ancora nessuna conversazione", startNew: "Avvia una nuova conversazione", supportTeam: "Team di supporto",
            loadFailed: "Impossibile caricare i messaggi",
            helpSearch: "Cerca nella guida…", articleCount: "{n} articoli", helpEmpty: "Nessun risultato", startChat: "Avvia una chat", collections: "Raccolte", articles: "Articoli", helpLoadFailed: "Impossibile caricare il contenuto",
        },
        akinon: {
            chooseAddress: "Seleziona un indirizzo",
            useMap: "Usa la mappa",
            selectCountry: "Seleziona un paese",
            country: "Paese",
            send: "Invia",
            selectCity: "Seleziona una città",
            city: "Città",
            selectState: "Seleziona uno stato",
            state: "Stato",
        },
        visitorLanguage: {
            rateTheMeting: "valuta la tua conversazione",
            rateTheEmptyMeting: "Vuoi valutare la conversazione?",
            confirmExperience: "Valuta l'esperienza di SUPSIS",
            addFile: "Aggiungi file",
            submitLocation: "Invia posizione",
            customerRepresentative: "Rappresentante del cliente",
            emailAdress: "Indirizzo email",
            send: "Invia",
            evaluation: "Per la valutazione",
            thankYouEvaluation: "Grazie per la valutazione!",
            hasEmailError: "Email non valida",
            reconnect: "Riconnetti",
            sendTheConversationToEmail: "Invia la conversazione via email",
            youDidNotAllowLocationAccess: "Non hai consentito l'accesso alla posizione!",
            allowLocationAccess: "Vuoi concedere l'accesso alla posizione?",
            locationNotSupported: "Il servizio di posizione non è supportato da questo browser.",
            deleteConversation: "Sei sicuro di voler eliminare tutte le tue informazioni?",
            endTheConversation: "Sei sicuro di voler terminare la conversazione?",
            suggestionAndOpinion: "Fornisci suggerimenti e opinioni",
            suggestion: "Valuta la tua conversazione.",
            skip: "Salta",
        },
    },
};

// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "en",
    messages, // set locale messages
});
window.i18n = i18n;



// WEBPACK FOOTER //
// ./src/language/index.js